var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2435 12.4087L9.71304 8.86087C10.3565 8.02609 10.7391 7 10.7391 5.86957C10.7391 3.1913 8.54783 1 5.86957 1C3.1913 1 1 3.1913 1 5.86957C1 8.54783 3.1913 10.7391 5.86957 10.7391C7.17391 10.7391 8.35652 10.2174 9.24348 9.38261L12.7565 12.8957C12.8261 12.9652 12.913 13 13 13C13.087 13 13.1739 12.9652 13.2435 12.8957C13.3826 12.7565 13.3826 12.5478 13.2435 12.4087ZM5.86957 10.0435C3.57391 10.0435 1.69565 8.16522 1.69565 5.86957C1.69565 3.57391 3.57391 1.69565 5.86957 1.69565C8.16522 1.69565 10.0435 3.57391 10.0435 5.86957C10.0435 8.16522 8.16522 10.0435 5.86957 10.0435Z",
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.90f8d7a965f24d85dd03a63a0ce4fcbc.svg";
export { ForwardRef as ReactComponent };